// extracted by mini-css-extract-plugin
export default {"overlay-textarea":"overlay-textarea_overlay-textarea__UN8-1"};